export default __webpack_public_path__ + "static/media/group-chat-icon.48f12304.svg";